module.exports = __webpack_public_path__ + "img/mod_6.5246db1e.png";